// Generated from grammarParser.g4 by ANTLR 4.7.2
// jshint ignore: start
var antlr4 = require("antlr4/index");
var grammarParserListener = require("./grammarParserListener")
  .grammarParserListener;

var serializedATN = [
  "\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
  "\u0003\u00125\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
  "\u0004\u0004\u0005\t\u0005\u0003\u0002\u0006\u0002\f\n\u0002\r\u0002",
  "\u000e\u0002\r\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003",
  "\u0003\u0003\u0003\u0005\u0003\u0016\n\u0003\u0003\u0004\u0003\u0004",
  "\u0005\u0004\u001a\n\u0004\u0003\u0004\u0003\u0004\u0005\u0004\u001e",
  '\n\u0004\u0003\u0004\u0003\u0004\u0005\u0004"\n\u0004\u0003\u0004\u0003',
  "\u0004\u0005\u0004&\n\u0004\u0003\u0004\u0003\u0004\u0005\u0004*\n\u0004",
  "\u0003\u0004\u0003\u0004\u0005\u0004.\n\u0004\u0005\u00040\n\u0004\u0003",
  "\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0002\u0002\u0006\u0002\u0004",
  "\u0006\b\u0002\u0002\u0002=\u0002\u000b\u0003\u0002\u0002\u0002\u0004",
  "\u0011\u0003\u0002\u0002\u0002\u0006/\u0003\u0002\u0002\u0002\b1\u0003",
  "\u0002\u0002\u0002\n\f\u0005\u0004\u0003\u0002\u000b\n\u0003\u0002\u0002",
  "\u0002\f\r\u0003\u0002\u0002\u0002\r\u000b\u0003\u0002\u0002\u0002\r",
  "\u000e\u0003\u0002\u0002\u0002\u000e\u000f\u0003\u0002\u0002\u0002\u000f",
  "\u0010\u0007\u0002\u0002\u0003\u0010\u0003\u0003\u0002\u0002\u0002\u0011",
  "\u0012\u0007\u0003\u0002\u0002\u0012\u0013\u0007\f\u0002\u0002\u0013",
  "\u0015\u0005\u0006\u0004\u0002\u0014\u0016\u0007\u0011\u0002\u0002\u0015",
  "\u0014\u0003\u0002\u0002\u0002\u0015\u0016\u0003\u0002\u0002\u0002\u0016",
  "\u0005\u0003\u0002\u0002\u0002\u0017\u0019\u0007\u0004\u0002\u0002\u0018",
  "\u001a\u0005\b\u0005\u0002\u0019\u0018\u0003\u0002\u0002\u0002\u0019",
  "\u001a\u0003\u0002\u0002\u0002\u001a0\u0003\u0002\u0002\u0002\u001b",
  "\u001d\u0007\r\u0002\u0002\u001c\u001e\u0005\b\u0005\u0002\u001d\u001c",
  "\u0003\u0002\u0002\u0002\u001d\u001e\u0003\u0002\u0002\u0002\u001e0",
  '\u0003\u0002\u0002\u0002\u001f!\u0007\b\u0002\u0002 "\u0005\b\u0005',
  '\u0002! \u0003\u0002\u0002\u0002!"\u0003\u0002\u0002\u0002"0\u0003',
  "\u0002\u0002\u0002#%\u0007\u0005\u0002\u0002$&\u0005\b\u0005\u0002%",
  "$\u0003\u0002\u0002\u0002%&\u0003\u0002\u0002\u0002&0\u0003\u0002\u0002",
  "\u0002')\u0007\u0006\u0002\u0002(*\u0005\b\u0005\u0002)(\u0003\u0002",
  "\u0002\u0002)*\u0003\u0002\u0002\u0002*0\u0003\u0002\u0002\u0002+-\u0007",
  "\u0003\u0002\u0002,.\u0005\b\u0005\u0002-,\u0003\u0002\u0002\u0002-",
  ".\u0003\u0002\u0002\u0002.0\u0003\u0002\u0002\u0002/\u0017\u0003\u0002",
  "\u0002\u0002/\u001b\u0003\u0002\u0002\u0002/\u001f\u0003\u0002\u0002",
  "\u0002/#\u0003\u0002\u0002\u0002/'\u0003\u0002\u0002\u0002/+\u0003",
  "\u0002\u0002\u00020\u0007\u0003\u0002\u0002\u000212\u0007\u000e\u0002",
  "\u000223\u0005\u0006\u0004\u00023\t\u0003\u0002\u0002\u0002\u000b\r",
  "\u0015\u0019\u001d!%)-/",
].join("");

var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map(function (ds, index) {
  return new antlr4.dfa.DFA(ds, index);
});

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  null,
  "'''",
  "'_'",
  "'\u2192'",
  "'\u03BB'",
  "'|'",
  null,
  null,
  "'\n'",
];

var symbolicNames = [
  null,
  "WDCOMPLEX",
  "WDSYMDIG",
  "APOSUPPW",
  "UNIUPPW",
  "LOWW",
  "UPPW",
  "DIGITS",
  "APOSTROPHE",
  "UNDERSCORE",
  "ARROW",
  "LAMBDA",
  "PIPE",
  "SYMBOLS",
  "NUMUNI",
  "NEWLINE",
  "WS",
];

var ruleNames = [
  "compilationUnit",
  "initialSetence",
  "setenses",
  "moreSetences",
];

function grammarParser(input) {
  antlr4.Parser.call(this, input);
  this._interp = new antlr4.atn.ParserATNSimulator(
    this,
    atn,
    decisionsToDFA,
    sharedContextCache
  );
  this.ruleNames = ruleNames;
  this.literalNames = literalNames;
  this.symbolicNames = symbolicNames;
  return this;
}

grammarParser.prototype = Object.create(antlr4.Parser.prototype);
grammarParser.prototype.constructor = grammarParser;

Object.defineProperty(grammarParser.prototype, "atn", {
  get: function () {
    return atn;
  },
});

grammarParser.EOF = antlr4.Token.EOF;
grammarParser.WDCOMPLEX = 1;
grammarParser.WDSYMDIG = 2;
grammarParser.APOSUPPW = 3;
grammarParser.UNIUPPW = 4;
grammarParser.LOWW = 5;
grammarParser.UPPW = 6;
grammarParser.DIGITS = 7;
grammarParser.APOSTROPHE = 8;
grammarParser.UNDERSCORE = 9;
grammarParser.ARROW = 10;
grammarParser.LAMBDA = 11;
grammarParser.PIPE = 12;
grammarParser.SYMBOLS = 13;
grammarParser.NUMUNI = 14;
grammarParser.NEWLINE = 15;
grammarParser.WS = 16;

grammarParser.RULE_compilationUnit = 0;
grammarParser.RULE_initialSetence = 1;
grammarParser.RULE_setenses = 2;
grammarParser.RULE_moreSetences = 3;

function CompilationUnitContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = grammarParser.RULE_compilationUnit;
  return this;
}

CompilationUnitContext.prototype = Object.create(
  antlr4.ParserRuleContext.prototype
);
CompilationUnitContext.prototype.constructor = CompilationUnitContext;

CompilationUnitContext.prototype.EOF = function () {
  return this.getToken(grammarParser.EOF, 0);
};

CompilationUnitContext.prototype.initialSetence = function (i) {
  if (i === undefined) {
    i = null;
  }
  if (i === null) {
    return this.getTypedRuleContexts(InitialSetenceContext);
  } else {
    return this.getTypedRuleContext(InitialSetenceContext, i);
  }
};

CompilationUnitContext.prototype.enterRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.enterCompilationUnit(this);
  }
};

CompilationUnitContext.prototype.exitRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.exitCompilationUnit(this);
  }
};

grammarParser.CompilationUnitContext = CompilationUnitContext;

grammarParser.prototype.compilationUnit = function () {
  var localctx = new CompilationUnitContext(this, this._ctx, this.state);
  this.enterRule(localctx, 0, grammarParser.RULE_compilationUnit);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 9;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    do {
      this.state = 8;
      this.initialSetence();
      this.state = 11;
      this._errHandler.sync(this);
      _la = this._input.LA(1);
    } while (_la === grammarParser.WDCOMPLEX);
    this.state = 13;
    this.match(grammarParser.EOF);
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function InitialSetenceContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = grammarParser.RULE_initialSetence;
  return this;
}

InitialSetenceContext.prototype = Object.create(
  antlr4.ParserRuleContext.prototype
);
InitialSetenceContext.prototype.constructor = InitialSetenceContext;

InitialSetenceContext.prototype.WDCOMPLEX = function () {
  return this.getToken(grammarParser.WDCOMPLEX, 0);
};

InitialSetenceContext.prototype.ARROW = function () {
  return this.getToken(grammarParser.ARROW, 0);
};

InitialSetenceContext.prototype.setenses = function () {
  return this.getTypedRuleContext(SetensesContext, 0);
};

InitialSetenceContext.prototype.NEWLINE = function () {
  return this.getToken(grammarParser.NEWLINE, 0);
};

InitialSetenceContext.prototype.enterRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.enterInitialSetence(this);
  }
};

InitialSetenceContext.prototype.exitRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.exitInitialSetence(this);
  }
};

grammarParser.InitialSetenceContext = InitialSetenceContext;

grammarParser.prototype.initialSetence = function () {
  var localctx = new InitialSetenceContext(this, this._ctx, this.state);
  this.enterRule(localctx, 2, grammarParser.RULE_initialSetence);
  var _la = 0; // Token type
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 15;
    this.match(grammarParser.WDCOMPLEX);
    this.state = 16;
    this.match(grammarParser.ARROW);
    this.state = 17;
    this.setenses();
    this.state = 19;
    this._errHandler.sync(this);
    _la = this._input.LA(1);
    if (_la === grammarParser.NEWLINE) {
      this.state = 18;
      this.match(grammarParser.NEWLINE);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function SetensesContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = grammarParser.RULE_setenses;
  return this;
}

SetensesContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
SetensesContext.prototype.constructor = SetensesContext;

SetensesContext.prototype.WDSYMDIG = function () {
  return this.getToken(grammarParser.WDSYMDIG, 0);
};

SetensesContext.prototype.moreSetences = function () {
  return this.getTypedRuleContext(MoreSetencesContext, 0);
};

SetensesContext.prototype.LAMBDA = function () {
  return this.getToken(grammarParser.LAMBDA, 0);
};

SetensesContext.prototype.UPPW = function () {
  return this.getToken(grammarParser.UPPW, 0);
};

SetensesContext.prototype.APOSUPPW = function () {
  return this.getToken(grammarParser.APOSUPPW, 0);
};

SetensesContext.prototype.UNIUPPW = function () {
  return this.getToken(grammarParser.UNIUPPW, 0);
};

SetensesContext.prototype.WDCOMPLEX = function () {
  return this.getToken(grammarParser.WDCOMPLEX, 0);
};

SetensesContext.prototype.enterRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.enterSetenses(this);
  }
};

SetensesContext.prototype.exitRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.exitSetenses(this);
  }
};

grammarParser.SetensesContext = SetensesContext;

grammarParser.prototype.setenses = function () {
  var localctx = new SetensesContext(this, this._ctx, this.state);
  this.enterRule(localctx, 4, grammarParser.RULE_setenses);
  var _la = 0; // Token type
  try {
    this.state = 45;
    this._errHandler.sync(this);
    switch (this._input.LA(1)) {
      case grammarParser.WDSYMDIG:
        this.enterOuterAlt(localctx, 1);
        this.state = 21;
        this.match(grammarParser.WDSYMDIG);
        this.state = 23;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 22;
          this.moreSetences();
        }

        break;
      case grammarParser.LAMBDA:
        this.enterOuterAlt(localctx, 2);
        this.state = 25;
        this.match(grammarParser.LAMBDA);
        this.state = 27;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 26;
          this.moreSetences();
        }

        break;
      case grammarParser.UPPW:
        this.enterOuterAlt(localctx, 3);
        this.state = 29;
        this.match(grammarParser.UPPW);
        this.state = 31;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 30;
          this.moreSetences();
        }

        break;
      case grammarParser.APOSUPPW:
        this.enterOuterAlt(localctx, 4);
        this.state = 33;
        this.match(grammarParser.APOSUPPW);
        this.state = 35;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 34;
          this.moreSetences();
        }

        break;
      case grammarParser.UNIUPPW:
        this.enterOuterAlt(localctx, 5);
        this.state = 37;
        this.match(grammarParser.UNIUPPW);
        this.state = 39;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 38;
          this.moreSetences();
        }

        break;
      case grammarParser.WDCOMPLEX:
        this.enterOuterAlt(localctx, 6);
        this.state = 41;
        this.match(grammarParser.WDCOMPLEX);
        this.state = 43;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if (_la === grammarParser.PIPE) {
          this.state = 42;
          this.moreSetences();
        }

        break;
      default:
        throw new antlr4.error.NoViableAltException(this);
    }
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

function MoreSetencesContext(parser, parent, invokingState) {
  if (parent === undefined) {
    parent = null;
  }
  if (invokingState === undefined || invokingState === null) {
    invokingState = -1;
  }
  antlr4.ParserRuleContext.call(this, parent, invokingState);
  this.parser = parser;
  this.ruleIndex = grammarParser.RULE_moreSetences;
  return this;
}

MoreSetencesContext.prototype = Object.create(
  antlr4.ParserRuleContext.prototype
);
MoreSetencesContext.prototype.constructor = MoreSetencesContext;

MoreSetencesContext.prototype.PIPE = function () {
  return this.getToken(grammarParser.PIPE, 0);
};

MoreSetencesContext.prototype.setenses = function () {
  return this.getTypedRuleContext(SetensesContext, 0);
};

MoreSetencesContext.prototype.enterRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.enterMoreSetences(this);
  }
};

MoreSetencesContext.prototype.exitRule = function (listener) {
  if (listener instanceof grammarParserListener) {
    listener.exitMoreSetences(this);
  }
};

grammarParser.MoreSetencesContext = MoreSetencesContext;

grammarParser.prototype.moreSetences = function () {
  var localctx = new MoreSetencesContext(this, this._ctx, this.state);
  this.enterRule(localctx, 6, grammarParser.RULE_moreSetences);
  try {
    this.enterOuterAlt(localctx, 1);
    this.state = 47;
    this.match(grammarParser.PIPE);
    this.state = 48;
    this.setenses();
  } catch (re) {
    if (re instanceof antlr4.error.RecognitionException) {
      localctx.exception = re;
      this._errHandler.reportError(this, re);
      this._errHandler.recover(this, re);
    } else {
      throw re;
    }
  } finally {
    this.exitRule();
  }
  return localctx;
};

exports.grammarParser = grammarParser;
